import { useMemberMarkAsReadMutation } from "@circle-react/lib/queries/communityInboxChats";
import { useEffect } from "react";

export const useMarkAvatarChatAsRead = (
  chatId: number | null,
  unreadCount: number | undefined,
) => {
  const { mutate } = useMemberMarkAsReadMutation();

  useEffect(() => {
    if (chatId && unreadCount) mutate({ id: chatId });
  }, [chatId, unreadCount, mutate]);
};
